import DashboardView from '@/views/app/dashboard/dashboard-view.vue'

export default [
  {
    path: 'dashboard',
    name: 'dashboard',
    component: DashboardView
  }
]



// WEBPACK FOOTER //
// ./src/router/app/dashboard/index.js